module.exports = __webpack_public_path__ + "img/00021.8f000b91.webp";